import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const STYLES = {
  pending: "text-slate-400 border-slate-700",
  reviewed: "text-blue-300 border-blue-500/40 bg-blue-500/10",
  paid: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10",
};

export function StatusSelect({ month, agent, onChange }) {
  const set = async (status) => {
    try {
      const { data } = await api.put(`/payouts/${month}/${agent.agent_id}`, { status });
      toast.success(`${agent.name}: marked ${status}`);
      if (data.notice === "sent") toast.success(`Payment notice emailed to ${agent.name}`);
      else if (data.notice) toast.error(`Payment notice ${data.notice}`);
      onChange();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Select value={agent.status} onValueChange={set}>
      <SelectTrigger data-testid={`status-select-${agent.agent_code}`} className={`h-7 w-28 text-xs font-mono uppercase ${STYLES[agent.status]}`}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="pending">Pending</SelectItem>
        <SelectItem value="reviewed">Reviewed</SelectItem>
        <SelectItem value="paid">Paid</SelectItem>
      </SelectContent>
    </Select>
  );
}

export function StatusBadge({ status }) {
  if (!status?.status || status.status === "pending") return <span data-testid="payout-status-badge" className={`font-mono text-xs px-2.5 py-1 rounded border uppercase ${STYLES.pending}`}>Pending review</span>;
  const when = status.status === "paid" ? status.paid_at : status.reviewed_at;
  return (
    <span data-testid="payout-status-badge" className={`font-mono text-xs px-2.5 py-1 rounded border uppercase ${STYLES[status.status]}`}>
      {status.status}{when ? ` · ${new Date(when).toLocaleDateString()}` : ""}
    </span>
  );
}
